import { ListSortLabelModel } from './label.model';

export class ListSortSetGlobalAction {
  constructor(public global: ListSortLabelModel[]) {}
}
